"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const mobx_react_1 = require("mobx-react");
const NakedButton_1 = require("@Components/Buttons/NakedButton");
const CardResults_1 = __importDefault(require("@Components/CardResults"));
const CatalogExtendedWorkItem_1 = __importDefault(require("@Components/WorkItemV2/Catalog/CatalogExtendedWorkItem"));
const contexts_1 = require("@App/contexts");
const uuid_1 = require("uuid");
const cardResultsDivClassName = 'public-search-results-table';
const PartyWorksTable = ({ searchPartyStore }) => {
    var _a, _b;
    const { publicViewWorkStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const onChangePage = (pagination) => __awaiter(void 0, void 0, void 0, function* () {
        yield searchPartyStore.onChangeWorksPage(pagination);
    });
    const onChangeLimit = (newLimit) => __awaiter(void 0, void 0, void 0, function* () {
        yield searchPartyStore.onChangeWorkResultsLimit(newLimit);
    });
    const count = ((_a = searchPartyStore.selectedWorks) === null || _a === void 0 ? void 0 : _a.count) || 0;
    const paginationInfo = searchPartyStore.publicSearchByPartyWorksPaginationInfo;
    const limit = searchPartyStore.currentWorkResultsPerPageLimit;
    const numTitles = searchPartyStore.partyWorksNumTitles;
    const worksResultMessage = searchPartyStore.worksResultMessage;
    const handleClickCard = (selectedWork) => {
        publicViewWorkStore.setViewWorkPublic(selectedWork);
    };
    const workItemDataList = ((_b = searchPartyStore.selectedWorks) === null || _b === void 0 ? void 0 : _b.works.map((work) => ({
        work,
        handleOnClick: handleClickCard,
        getId: () => work.id || (0, uuid_1.v4)(),
        displayType: searchPartyStore.displayType,
    }))) || [];
    return (react_1.default.createElement("div", { className: "party-works-table" },
        react_1.default.createElement(NakedButton_1.NakedButton, { onClick: () => searchPartyStore.setShowWorks(false) }, "< Back"),
        react_1.default.createElement(CardResults_1.default, { data: workItemDataList, count: count, limit: limit, paginationInfo: paginationInfo, extendedCardType: CatalogExtendedWorkItem_1.default, onChangePage: onChangePage, onChangeLimit: onChangeLimit, paginationResultsMessage: worksResultMessage, numTitlesProps: numTitles, outerDivClassName: cardResultsDivClassName })));
};
exports.default = (0, mobx_react_1.observer)(PartyWorksTable);
